import React from 'react'
import { func, object } from 'prop-types'
import { translate } from 'react-i18next'
import { Payment } from '../payment/Payment'

export const InquiryDetailsPayment = translate()(({ t, payment }) => {
  return (
    <div>
      <p>
        { t('common:payment:payment_prestation_message_second_1' + (payment.advance > 0 ? '_acompte' : '')) }<br />
        { t('common:payment:payment_prestation_message_second_2' + (payment.advance > 0 ? '_acompte' : '')) }
      </p>
      <Payment payment={payment} />
    </div>
  )
})

InquiryDetailsPayment.propTypes = {
  t: func,
  payment: object
}



// WEBPACK FOOTER //
// ./src/components/inquiries/InquiryDetailsPayment.js